import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Terms.css";
import { Link } from "react-router-dom";
import ProgressLoader from "../Loader/ProgressLoader";

const TermsAndConditionsPage = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Home_TermsAndCondition"
      );
      setFetchedData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

    if (loading) {
    return(
      <div className="text-center my-5">
        <p className="mt-2">Loading Privacy Policy...</p>
        <ProgressLoader />
      </div>
    )
  }
  return (
    <>
      <div className="terms-container py-5">
        <div className="container">
          <h1 className="text-center mb-4">Terms and Conditions</h1>
          <p className="text-muted text-center mb-5">
            Please read these terms and conditions carefully before using our
            website.
          </p>
          {fetchedData?.map((item) => (
            <>
              <div className="terms-section mb-4">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </>
          ))}

          <div className="text-center mt-5">
            <p className="text-muted">
              If you have any questions regarding our terms, feel free to{" "}
              <Link to="/contactus" className="terms-link">
                contact us
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionsPage;
